import axiosInstance from './axios';
import joinURLParams from 'utils/joinUrlParams';
import PaginationData from 'types/models/PaginationData';
import Permission from 'types/models/Permission';

export const getPermissionsWithPagination = async (
  page?: number,
  searchTerm?: string,
): Promise<PaginationData<Permission>> => {
  const url = joinURLParams({ page: page ?? 1, searchTerm }, `permissions`);
  try {
    const { data: paginationData } = await axiosInstance({
      method: 'get',
      url,
    });
    return {
      currentPage: paginationData.current_page,
      data: paginationData.data,
      perPage: paginationData.per_page,
      total: paginationData.total,
    };
  } catch (error) {
    console.log('error(getPermissionsWithPagination', error);
    throw error;
  }
};

export const updatePermissions = async (id: string, data: Partial<Permission>): Promise<Permission> => {
  try {
    const { data: permission } = await axiosInstance({
      method: 'put',
      url: `permissions/${id}`,
      data,
    });
    return permission;
  } catch (error) {
    console.log('error(updatePermissions', error);
    throw error;
  }
};

export const getMyPermissions = async (): Promise<string[]> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: 'permissions/me',
    });
    return data;
  } catch (error) {
    console.log('error(getMyPermissions)', error);
    throw error;
  }
};
